$(window).load(function(){
  window.productItemColor = {
    'Aloe': '#a9d08f',
    'Army': '#8e735e',
    'Ash Grey SF': '#cddbcf',
    'Asphalt': '#262626',
    'Baby Blue': '#91bee9',
    'Beige': '#d1b98d',
    'Black': '#000000',
    'BlackWhite': '#000000',
    'Blue': '#0066ce',
    'Blue Spruce': '#00769e',
    'Blush': '#ffcdea',
    'Brown': '#723100',
    'Burgundy': '#590000',
    'Burnt Orange': '#c55910',
    'Camel': '#864a12',
    'Carbon': '#404040',
    'Cardinal': '#96002a',
    'Charcoal': '#393939',
    'Cobalt': '#0166ff',
    'Copper': '#c55911',
    'Coral': '#ff5960',
    'Cream': '#fffdd0',
    'Dark Brown': '#311500',
    'Dark Green': '#385624',
    'Dark Grey': '#3a3839',
    'Dark Navy': '#203763',
    'Dark Red': '#c00000',
    'Denim': '#203763',
    'Ebony': '#000000',
    'Eggplant': '#552a5c',
    'Emerald': '#009900',
    'Forest': '#034100',
    'Gold': '#efa101',
    'Graphite': '#3a3839',
    'Green Lapis': '#00b050',
    'Green': '#00b133',
    'Grey Navy': '#222b35',
    'Grey Truffle': '#6d323a',
    'Grey': '#928f98',
    'Heather Black': '#404040',
    'Heather Galapagos Blue': '#00b1f1',
    'Heather Grey': '#d9d9d9',
    'Heather Navy': '#203763',
    'Heather Red': '#ff3334',
    'HthrBlackBlack': '#525252',
    'Indigo': '#2d2d87',
    'Iron': '#757170',
    'Ivory': '#fffff3',
    'Jade': '#339967',
    'Juniper': '#2a8156',
    'Kelly Green': '#0a8249',
    'Khaki': '#fedcb9',
    'Lapis': '#23377c',
    'Lavender': '#bfb0d6',
    'Leaf': '#538234',
    'Lemon': '#fff700',
    'Lieutenant': '#67695a',
    'Light Black': '#161616',
    'Light Blue': '#79d4ff',
    'Light Brown': '#b5662c',
    'Light Green': '#78ff71',
    'Light Grey': '#c4c4c4',
    'Light Navy': '#000080',
    'Light Pink': '#ffb6c1',
    'Light Red': '#bf0000',
    'Lilac': '#cc99fe',
    'Lime': '#cff2dc',
    'Loden': '#578200',
    'Maroon': '#800000',
    'Mauve': '#dac0c4',
    'Mint': '#98ff98',
    'Mustard': '#dea500',
    'Navy': '#003448',
    'NeoHtrBlue': '#00b0f0',
    'Neon Green': '#a2e96f',
    'Neon Orange': '#fD5f00',
    'Neon Pink': '#ffa3bc',
    'Neon Yellow': '#e0fc5d',
    'Olive': '#3d4c3a',
    'Onyx': '#000000',
    'Orange': '#e96b19',
    'Orchid': '#cb00cc',
    'Peach': '#f7d0c1',
    'Pewter': '#bfbfbf',
    'Pink': '#ff3d6b',
    'Purple': '#7e5d98',
    'Raspberry': '#bf0076',
    'Red': '#ae001a',
    'Red Navy': '#ff0000',
    'Regatta Blue': '#0094ce',
    'Rose': '#ff339a',
    'Royal': '#0000fe',
    'Royal Blue': '#0662c1',
    'Sangria': '#c9004e',
    'Sapphire': '#0166ff',
    'Sea Foam': '#e0ebe3',
    'Silver': '#bfc8cc',
    'Smoke': '#3a3839',
    'Steel Blue': '#00769e',
    'Tan': '#d2b48c',
    'Tangerine': '#ed7d31',
    'Teal': '#008080',
    'Tropical Blue': '#00ccff',
    'Truffle': '#6d323a',
    'Turquoise': '#00afb1',
    'Violet': '#9933ff',
    'White': '#ffffff',
    'WhiteBlack': '#ffffff',
    'WhiteHthBlack': '#525252',
    'WhiteHthLkeBlu': '#449bac',
    'Wine': '#990134',
    'Yellow': '#f0e000',
  }

  window.searchConfig = {
    facets: {},
    sort: {
      field: undefined,
      direction: undefined
    }
  };

  window.winWidth = parseInt($(window).width(),10);
  window.itemCount = '';
  window.value = '';
  window.oldSearchQuery = null;
  window.oldFacets = null;
  window.newSearchQuery = null;

  // This function returns an array of all url parameters for the current window
  window.getAllUrlParams = function(url) {
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};
    if (queryString) {
      queryString = queryString.split('#')[0];
      var arr = queryString.split('&');
  
      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
        paramName = paramName.toLowerCase();

        if (typeof paramValue === 'string') {
          paramValue = paramValue.toLowerCase();
        }

        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');

          if (!obj[key]) {
            obj[key] = [];
          } 

          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string'){
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }
    return obj;
  }

  // This function either redirects the user to the correct search url or does nothing, depending on if a user is coming from an AMP page
  window.identifyAmpSubmissions = function() {
    var url = document.URL;
    var params = getAllUrlParams(url);
    if (params.amp === "true") {
      redirectAmpSubmissions();
    } else {
      return false;
    }
  }

  // This function performs the redirect to the search results with a corrected search query syntax if needed. The identifyAmpSubmissions() function makes this distinction.
  window.redirectAmpSubmissions = function() {
    var urlBase = window.location.href.split('?')[0];
    var oldQuery = window.location.search;
    var newQuery = oldQuery.replace("?", "#");
    var fullUrl = urlBase + newQuery;
    window.location.replace(fullUrl); 
  }

  identifyAmpSubmissions();
  
  window.customRenderFunction = function(document_type, item) {
    var date = new Date(item['published_on']);
    var html = "";
    var data = '';
    if (typeof item['price'] !== 'number') {
      var itemPrice = ''; 
    } else {
      var itemPrice = '$' + parseFloat(item['price']).toFixed(2);
    }
    var pipe = item['title'].indexOf('|');
    var title = item['title'].substring(0, pipe != -1 ? pipe : item['title'].length).trim();
    if( typeof item['title'] != 'undefined' || item['title'] != '' ){
      data += '<div class="col-xs-6 col-sm-6 col-md-4 no-padding product-list "><div class="scaleOnHover product-list-inner"><div class="product-area text-center clearfix"><div class="product-info"><div class="product-thumbnail"><a href="'+item['url']+'"><img src="'+item['image']+'" alt="'+title+'"></a></div><h4><a href="'+item['url']+'">'+title+'</a></h4><div class="price">MSRP: <span class="product-price"><span class="money">'+itemPrice+'</span></span></div></div></div></div></div>';
    }
    html = data;
    return html;
  };

  window.$facetContainer = $('.st-dynamic-facets');

  window.reloadResults = function() {
    dbCnvrtCurrent();
    $('#st-results-container2').empty();
    $(window).hashchange(); // This hashchange is required for the search results to refresh
  };

  window.bindControls = function(data) {
    dbCnvrtCurrent();

    var totalResultCount = 0;
    var $resultContainer = this.getContext().resultContainer;
    var spellingSuggestion = null;

    window.urlHash = location.hash.split('&');
    window.urlQuery = window.urlHash[0];
    var
      resultInfo = data['info'],
      str = '',
      facets = '';

    window.isSearchSubmitted = false;

    var totalNumPages = resultInfo['page']['num_pages'];
    var totalResults = resultInfo['page']['total_result_count'];
    window.newSearchQuery = resultInfo['page']['query'];

    if( totalResults <= 15 && totalNumPages < 2){
      location.hash = window.urlQuery + "&stp=" + totalNumPages;
    }

      $.each(resultInfo, function(documentType, typeInfo){

        totalResultCount += typeInfo['total_result_count'];

        if ( typeInfo['spelling_suggestion'] ) {
          spellingSuggestion = typeInfo['spelling_suggestion']['text'];
        }

        if (totalResultCount === 0 ) {
          $resultContainer.html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found.</strong></div>');
        }

        if (spellingSuggestion !== null) {
          $resultContainer.append('<div class="st-spelling-suggestion alert alert-info mb0 text-center col-sm-12">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</div>');
        }

        /********************** Render facets based on user queries *********************/
        var tempFacets;
        if( window.oldSearchQuery == window.newSearchQuery && (window.oldFacets != null && window.oldFacets != '') ){
          tempFacets = window.oldFacets;
        }else{
          window.oldFacets = typeInfo.facets;
          tempFacets = typeInfo.facets;
          window.oldSearchQuery = window.newSearchQuery;

        }



        var facetNo = 0;
          $.each(tempFacets, function(field, facetCounts) {
            facetNo++;
            if( field == 'quick_ship'){
              str = 'quick ship';
            }else{
              str = field;
            }
            var filterTitle = str;
            var facetFound = 0;
            var quick_ship_flag = 0;

            var tempfacets = '';

            var filterSecClass = ($('.foption_box_'+facetNo).length > 0 && $('.foption_box_'+facetNo).is(':visible')) ? '' : 'hide-section';
            var arrowSecClass = ($('.foption_box_'+facetNo).length > 0 && $('.foption_box_'+facetNo).is(':visible')) ?  'slider-arrow-active' : '';

            tempfacets += ['<li class="clearfix filter"><a class="filterTitle" href="javascript:void(0)" >', filterTitle, '</a><a href="javascript:void(0);" class="slider-arrow '+arrowSecClass+'">3</a><ul class="coll-filter panel-mm  foption_box_'+facetNo+' '+filterSecClass+'">'].join('');
              //tempfacets += '<div style="margin: 0.25rem 0 0.75rem 0.5rem; font-size: 12px;">Sort: A-Z | Count </div>';

            $.each(facetCounts, function(label, count) {
              itemCount = count;
              var
                status = "",
                labelStr = "Quick Ship",
                id = encodeURIComponent(label).toLowerCase();
              if (window.searchConfig.facets[field] && window.searchConfig.facets[field].indexOf(label) > -1) {
                status = 'checked="checked"'
              }

              if( label == '1'){
                label = labelStr;
                value = 1;
              }else{
                label = label;
                value = label;
              }

              if(count > 0 && label != quick_ship_flag){
                tempfacets += '<li class="search-radio"><label for="' + id + '"><input type="checkbox"' + status + ' name="' + field + '" value="' + value + '" id="' + id + '">';
                if(field == 'color')
                {
                  if( typeof productItemColor[label] != 'undefined' ){
                    var product_color =  productItemColor[label];
                  }else{
                    var product_color = '';
                  }

                  tempfacets += '<span class="product-filter-label"><span class="product-color" style="background-color:'+ product_color +'"></span>' + label + '</span> ('+count+')</label></li>';
                }
                else
                {
                  tempfacets += '<span class="product-filter-label">' + label + '</span></label> ('+count+')</li>';
                }

                facetFound++;
              }

            });

            if( itemCount > 0){
              tempfacets += '<a href="#" class="clear-selection" data-name="' + field + '">Clear all</a></ul></li>';
            }

            if(facetFound > 0){
              facets += tempfacets;
            }

          });
          $facetContainer.html(facets);
      });

  };

  window.readSortField = function() {
    return { page: window.searchConfig.sort.field };
  };

  window.readSortDirection = function() {
    return { page: window.searchConfig.sort.direction };
  };

  window.isSearchSubmitted = false;
  window.readFilters = function() {
    
    var temPage =  {};
    
    if(window.isSearchSubmitted){
      window.searchConfig.facets['brand'] = '';
      window.searchConfig.facets['color'] = '';
      window.searchConfig.facets['material'] = '';
      window.searchConfig.facets['style'] = '';
      window.searchConfig.facets['quick_ship'] = '';
      
      temPage['DISCONTINUED'] = 0;
      // Filter out collections and pages from search results page
      temPage['type'] = 'product';
      
      return {
        page: temPage
      }
    }else{
      
      if(typeof window.searchConfig.facets['brand'] != "undefined" && window.searchConfig.facets['brand'] != ""){
          temPage['brand'] = window.searchConfig.facets['brand'];
      }

      if(typeof window.searchConfig.facets['color'] != "undefined" && window.searchConfig.facets['color'] != ""){
          temPage['color'] = window.searchConfig.facets['color'];
      }

      if(typeof window.searchConfig.facets['material'] != "undefined" && window.searchConfig.facets['material'] != ""){
          temPage['material'] = window.searchConfig.facets['material'];
      }

      if(typeof window.searchConfig.facets['style'] != "undefined" && window.searchConfig.facets['style'] != ""){
          temPage['style'] = window.searchConfig.facets['style'];
      }

      if(typeof window.searchConfig.facets['quick_ship'] != "undefined" && window.searchConfig.facets['quick_ship'] != ""){
          temPage['quick_ship'] = window.searchConfig.facets['quick_ship'];
      }
      
      temPage['DISCONTINUED'] = 0;
      // Filter out collections and pages from search results page
      temPage['type'] = 'product';
      
      return {
        page: temPage
      }

    }
  }

  window.customOnComplete = function(elem) {
    dbCnvrtCurrent();
    window.location = elem.attr('href');
  };

  window.customAutocompleteDesign = function(document_type, item) {
    if (typeof item['price'] !== 'number') {
      var itemPrice = ''; 
    } else {
      var itemPrice = '$' + parseFloat(item['price']).toFixed(2);
    }
    var out ='';
     out += '<div class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+item['image']+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p><div class="autocompleteItemPrice"><span class="product-price"><span class="money">'+itemPrice+'</span></span></div></div></div>';
    return out;
  };

  window.footerCustomAutocompleteDesign = function(document_type, item) {
    if (typeof item['price'] !== 'number') {
      var itemPrice = ''; 
    } else {
      var itemPrice = '$' + parseFloat(item['price']).toFixed(2);
    }
    var out ='';
     out += '<div id="footer-autocomplete" class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+item['image']+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p><div class="autocompleteItemPrice"><span class="product-price"><span class="money">'+itemPrice+'</span></span></div></div></div>';
    return out;
  };

  window.customResultRenderFunction = function(ctx, results) {
    var $list = ctx.list,
      config = ctx.config;

    $.each(results, function(document_type, items) {
      $.each(items, function(idx, item) {
        var position = 0;
        if( item['type'] == 'product'){
          position = 1;
        }else if( item['type'] == 'collection'){
          position = 2;
        }else{
          position = 3;
        }
        ctx.registerResult($('<li class="autoCompleteResults" data-type="'+item['type']+'" data-position="'+position+'"><a href="'+item['url']+'">' + config.renderFunction(document_type, item) + '</a></li>').appendTo($list), item);
      });
    });
    var $temp = $('<ul></ul>');
    // Reverse the order of autocomplete search results so they match the order on the search results page (also, puts pinned products at the top)
    var listItems = $list.children('li');
    $list.append(listItems.get().reverse());
    $list.find('li').sort(sort_li).appendTo($temp);
    var currentType = '';
    $temp.find('li').each(function(){
      if( $(this).data('type') != '' && typeof $(this).data('type') != 'undefined' ){
        if( $(this).data('type') == 'page'){
          var type = 'BRANDS';
        }else{
          var type = ($(this).data('type').toUpperCase())+'S';
        }
        if(currentType != type){
          $('<li class="autoCompleteResults categotyTitle"><div class="autocompleteListWrapper"><div class="autocompleteItemTitle"><p class="title">'+type+'</p></div></div></li>').insertBefore($(this));
          currentType = type;
        }
      }

    });
    $list.html($temp.html());
    if (config.widgetContainerClass && config.widgetContainerClass != "swiftype-widget swiftype-widget-footer") {
      stopBodyScroll();
    }    
    dbCnvrtCurrent();
  };

  /***********Sort results data in categories *********************/
  function sort_li(a, b){
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;   
  }
  /******************************************************************/

  /************ Footer Dropdown Design *************************/
  var customDropdownStylesFunction = function($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.parent().parent().offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
      'bottom': (($(document).height()  - offset.top)  - ($attachEl.outerHeight()- 60)),
      'left': offset.left
    };
    if (config.setWidth) {
      styles['width'] = $attachEl.parent().parent().outerWidth();
    }
    return styles;
  };
  /*******************************************************************/


    /********************* Header search init ************************************/
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-results-container2',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: customRenderFunction,
      sortField: readSortField,
      sortDirection: readSortDirection,
      facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
      filters: readFilters,
      postRenderFunction: bindControls,
      perPage: 15,
      onComplete: customOnComplete, 
      spelling: 'strict',
    });
    /*****************************************************************************/

    /********************* Footer search init ************************************/
    $('#footer-search-textinput').change(function(){
     $('#st-search-input').val($('#footer-search-textinput').val());
    //  $('#st-search-input').parents('form').submit(); // when user change footer search and do not submit it. sync to top search
    });
    $('#st-search-input').change(function(){
     $('#footer-search-textinput').val($('#st-search-input').val());
    });
    /*****************************************************************************/

  /********* Header autocomplete search ***************************/
  $('#st-search-input').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customAutocompleteDesign,
    resultLimit: 7,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
    autocompleteContainingElement: '.header',
    dropdownStylesFunction: dropdownStylesFunction
  });

  function dropdownStylesFunction($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
    };
    if (window.innerWidth >= 767) {
      styles['left'] = offset.left-18;
    }
    if (config.setWidth) {
      styles['width'] = window.innerWidth < 767 ? '100%' : $attachEl.parent().parent().outerWidth();
    }
    return styles;
  
  };
  /**********************************************************/

  /********* Footer autocomplete search ***************************/
  $('#footer-search-textinput').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: footerCustomAutocompleteDesign,
    resultLimit: 7,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    suggestionListClass: 'footerResults',
    dropdownStylesFunction: customDropdownStylesFunction,
    widgetContainerClass: 'swiftype-widget swiftype-widget-footer',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
  });

  $('#footer-search-textinput').swiftypeSearch({
    resultContainingElement: '#st-results-container2',
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customRenderFunction,
    sortField: readSortField,
    sortDirection: readSortDirection,
    facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
    filters: readFilters,
    postRenderFunction: bindControls,
    perPage: 15,
    onComplete: customOnComplete, 
    spelling: 'strict',
  });
  /**********************************************************/

  $('.sort').on('click', function(e){
    e.preventDefault();
    $('.sort').removeClass('active');
    $(this).addClass('active');
    window.searchConfig.sort.field = $(this).data('field');
    window.searchConfig.sort.direction = $(this).data('direction');
    reloadResults();
  });

  $facetContainer.on('click', '.search-radio', function(e) {
    window.searchConfig.facets = {}; // Set the hash to empty
    $('.st-dynamic-facets input[type="checkbox"]').each(function(idx, obj) {
      var
        $checkbox = $(obj),
        facet = $checkbox.prop('name');
      if(!window.searchConfig.facets[facet]) {
        window.searchConfig.facets[facet] = [];
      }
      if($checkbox.prop('checked')) {
        window.searchConfig.facets[facet].push($checkbox.prop('value'));
      }
      location.hash = window.urlQuery + "&stp=1";
    });
    reloadResults();
  });

  $facetContainer.on('click', 'a.clear-selection', function(e) {
    e.preventDefault();
    location.hash = window.urlQuery + "&stp=1";
    var name = $(this).data('name');
    $('input[name=' + name + ']').prop('checked', false);
    window.searchConfig.facets[name] = [];
    reloadResults();
  });

  /**** Sidebar dropdown animations *****/
  $('body').on("click", ".st-dynamic-facets .filter", function(e){
      if($(e.target).closest('label').length < 1){
        e.preventDefault();
        $(this).find('ul').slideToggle();
        $(this).find('a.slider-arrow').toggleClass('slider-arrow-active');
      }
  });

  $("body").on("click", "#sort-by-list li", function(){
    $("#sort-by-list").slideUp();
  });

  if( winWidth < 768){
    /* Product sort Mobile */
    $('body').on('click', '#sort-by-list li', function (e) {
      $('body').removeClass('active-short');
      $('html').removeClass('scrollHide');

    });

     /* Product filter mobile */
    $('body').on('click', '.st-dynamic-facets .filter .coll-filter label', function (e) {
      $('body').removeClass('active-filter');
      $('html').removeClass('scrollHide');
    });
  }

  var stopBodyScroll = function(){
    var headerHeight = parseInt($('.header').height(),10);
    var winHeight = parseInt($(window).height(),10);
    if(winWidth < 768){
      var listHeight = parseInt(winHeight - headerHeight, 10);
      if( $('.autoCompleteResults').is(':visible') == true || $('.new-search-input').val() != ''){
        $('.swiftype-widget .autocomplete').css('max-height', listHeight);
      }else{
        $('.swiftype-widget .autocomplete').css('max-height', 'auto');
      }
    }
  }
  $(window).on('resize', function(){
    stopBodyScroll();
  });

  /************** Header and Footer search form submit actions *************************/

  $('#search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#footer-search-textinput").val('');
    $(".search-form-footer").removeClass('form-open');
    $(".nav .cart-item").addClass('cart-item-hide');

    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#st-search-input").val();
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
    }else{
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + query;
      }
    }
  });

  $('#footer-search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#st-search-input").val('');
    $(".search-form").removeClass('form-open');
    $(".iconSearch").removeClass('icon_close');
    $(".iconSearch").addClass('icon_search');
    $(".nav .cart-item").removeClass('cart-item-hide');


    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#footer-search-textinput").val();
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
    }else{
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + query;
      }
    }
  });

  /**
   * modifications for search page and rendering Brands(pages) and Collections
   */
  let isRenderBnC = getFiltersBnC();
  if (isRenderBnC) {
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-collections',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('collections'),
      perPage: 3,
    });

    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-pages',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('pages'),
      perPage: 3,
    });
  }

  function filterBnC(type) {
    if (!document.querySelector('.searchBnCWrapper')) {
      return false;
    }
    document.querySelector('.searchBnCWrapper').style.display = 'none';
    let isRenderBnC = getFiltersBnC(),
      filterSettingsForCollection = {
        page: {
          'type': 'collection',
        }
      },
      filterSettingsForPage = {
        page: {
          'type': 'page',
        }
      };

    if (isRenderBnC) {
      
      if (type == 'collections') {
        return filterSettingsForCollection;
      } else if (type == 'pages') {
        return filterSettingsForPage;
      }
    } else {
      document.querySelector('.searchBnCWrapper').style.display = 'none';

      return false;
    }
    
  }
  
  function renderItemBnC(document_type, item) {
    if (item['type'] != 'product' && getFiltersBnC()) {
      document.querySelector('.searchBnCWrapper').style.display = 'block';

      let selector = '.'+item['type']+'sTitle',
        element = document.querySelector(selector);
      if (element.style.display == 'none') {
        element.style.display = 'list-item';
      }
      let data = '';
      if (typeof item['title'] != 'undefined' || item['title'] != '') {
        data = '<li class="autoCompleteResults" data-type="' + item['type'] + '" data-position="3"><a href="' + item['url'] + '"><div class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="' + item['image'] + '" alt="' + item['title'] + '"></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p></div></div></a></li>';
      }
      return data;
    }
  };

  function getFiltersBnC() {
    let filterNamesArray = ['brand', 'color', 'material', 'style', 'quick_ship'],
      isFilters = false;
    filterNamesArray.forEach(function(filterName) {
      if (window.searchConfig.facets[filterName] && window.searchConfig.facets[filterName].length) {
        isFilters = true;
      }
    });
    if (isFilters) {
      return false;
    } else {
      return true;
    }    
  }

});
